module.exports = __webpack_public_path__ + "static/media/syncari-logo.732422f1.svg";